module.exports = __webpack_public_path__ + "img/lesotho.df1ece0.webp";